import FileUpload from '@src/ui/elements/form/FileUpload';
import { useEffect, useState } from 'react';

import FieldErrorMessage from './FieldErrorMessage';

interface ImageUploadFieldProps {
  onUpload: (file: File | null) => Promise<string | null>;
  onDelete: (fileUrl: string) => void;
  preview?: string;
  isUploading: boolean;
  errors?: string[];
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  onUpload,
  preview,
  errors,
  onDelete,
}) => {
  const [localPreview, setLocalPreview] = useState<string | undefined>(preview);

  useEffect(() => {
    setLocalPreview(preview);
  }, [preview]);

  const handleFileChange = async (file: File | null) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLocalPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
    return onUpload(file);
  };

  return (
    <div className='flex flex-col gap-[6px]'>
      <p className='text-sm'>サムネイル画像</p>
      <FileUpload
        accept='image/jpeg, image/jpg, image/png, image/gif'
        maxSize={25 * 1024 * 1024}
        onFileChange={handleFileChange}
        defaultPreview={localPreview}
        onDelete={async () => {
          if (preview) {
            await onDelete(preview);
            setLocalPreview(undefined);
          }
        }}
      />
      <FieldErrorMessage errors={errors ?? []} />
    </div>
  );
};

export default ImageUploadField;
